module.exports = __webpack_public_path__ + "img/Ardunic Account page-111.975689b5.svg";